import { render } from "./MyHome.vue?vue&type=template&id=2ea7779c&scoped=true"
import script from "./MyHome.vue?vue&type=script&lang=js"
export * from "./MyHome.vue?vue&type=script&lang=js"

import "./MyHome.vue?vue&type=style&index=0&id=2ea7779c&scoped=true&lang=css"

import exportComponent from "/media/whoami/010101010/Prosofty/PublicOpinion/frontEnd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ea7779c"]])

export default __exports__